
import { useAnimationControls } from "framer-motion";
import { useEffect, useState } from "react";
import useToggle from "shared/hooks/useToggle";
import { EFace, ESuit } from "../enum";
import { createDeck } from "../utils/createDeck";

const useCardGame = () => {
    const [face, setFace] = useState(EFace["5"]);
    const [suit, setSuit] = useState(ESuit.CLUB);
    const [describe, setDescribe] = useState("");
    const [guide, setGuide] = useState("");
    const [deck, setDeck] = useState([]);
    const [count, setCount] = useState(0);
    const modal = useToggle();

    const controls = useAnimationControls();

    useEffect(() => {
        onReset();
    }, []);

    useEffect(() => {
        if (count === 4) return modal.on();
    }, [count]);

    const onFadeReset = () => {
        controls.set({ x: -80, opacity: 0 });
        controls.start({ x: 0, opacity: 1 });
    };

    const onFadeIn = async () => {
        await controls.start({ x: 120, opacity: 0 });
        controls.set({ x: -80, opacity: 0, transition: { delay: 0.3 } });
        controls.start({ x: 0, opacity: 1, transition: { delay: 0.3 } });
    };

    const onReset = () => {
        onFadeReset();
        setDeck(createDeck());
        setFace("");
        setSuit("");
        setCount(0);
        setDescribe("");
        setGuide("");
    };

    const onDraw = async () => {
        await onFadeIn();
        if (deck.length === 0) return alert(`หมด`);
        const draw = deck.pop();
        if (draw.face === "K") setCount(count + 1);
        setFace(draw.face);
        setSuit(draw.suit);
        setDeck([...deck]);
    };

    const onCloseModal = () => {
        modal.toggle();
        onReset();
    };

    return {
        face,
        suit,
        describe,
        setDescribe,
        guide,
        setGuide,
        deck,
        count,
        modal,
        controls,
        onDraw,
        onReset,
        onCloseModal,
    };
};

export default useCardGame;
